module.exports = __webpack_public_path__ + "img/fountain_of_blood_small.bdf10a50.png";